import React from 'react'

import Button from '../../../../../components/atoms/Button2'
import BaseModal from '../../../../../components/molecules/ChatModals/BaseModal'
import Instructions from './Instructions'

import useStyles from './styles'

const GetCode = ({ id }) => {
  const [open, setOpen] = React.useState(false)

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Button onClick={() => setOpen(true)} className={classes.button}>
        GET CODE
      </Button>

      {open && (
        <BaseModal
          open={open}
          onClose={() => {
            setOpen(false)
          }}
          title='GET CODE'
          PaperProps={{ style: { top: '53%', width: '30%' } }}
        >
          <Instructions id={id} />
          <div className={classes.buttonContainer}>
            <Button className={classes.button} onClick={() => setOpen(false)}>
              OK
            </Button>
          </div>
        </BaseModal>
      )}
    </div>
  )
}

export default GetCode
